import { SearchOutlined } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import React from 'react';

export const SearchIcon = (props: SvgIconProps) => {
  return <SearchOutlined {...props} />;
};
